import { Component } from '@angular/core';
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-help-info-dialog',
  templateUrl: './help-info-dialog.component.html',
  styleUrls: ['./help-info-dialog.component.scss'],
  imports: [MatDialogContent, MatDialogTitle, MatIconModule],
})
export class HelpInfoDialogComponent {
  constructor(public dialogRef: MatDialogRef<HelpInfoDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
